import type { UserRole } from '@/types';

export type { UserRole };

export type RawUserRole = UserRole | 'client' | null | undefined;

/**
 * Normalize any persisted role string into one of the canonical role values.
 * Older records might still use "client" – treat them as standard users.
 */
export function normalizeUserRole(role: RawUserRole): UserRole {
  if (!role) {
    return 'user';
  }

  const canonical = role.toLowerCase();
  if (canonical === 'admin' || canonical === 'provider') {
    return canonical;
  }

  return 'user';
}
